import React, { useState, useEffect } from "react";
import Loader from "./Loader";

const IClasses = {
    content: '',
    header: '',
    body: '',
    footer: ''
}

export default function Modal({
	show,
	toggle,
	blank,
	callback,
	children,
	title,
	acceptText,
	size = "sm",
	showCancelBtn = true,
	footer,
    classes = IClasses,
	closeWithEsc = true,
    saving = false
}) {
	const [mostrar, setMostrar] = useState(false);

	window.addEventListener("keyup", (e) => {
		if (closeWithEsc && e.key === "Escape") {
			setMostrar(false);
		}
	});

    const callbackWrapper = async () => {
        await callback ? callback() : toggle();
    }

	const modalSize = () => {
		if (size === "sm" || !size) return null;

		if (size === "lg") {
			return "80%";
		} else if (size === "md") {
			return "60%";
		}

		return size;
	};

	useEffect(() => {
		setMostrar(show);
	}, [show]);

	// `mostrar` lo sincroniza un efecto, así que va un commit por detrás de
	// `show`: al cerrar, el modal alcanza a renderizarse una vez más con los
	// datos que la pantalla ya limpió en el mismo evento —y el hijo revienta al
	// leerlos—. Con React 19 eso pasa siempre, porque agrupa los setState de una
	// función async. `mostrar` sigue mandando para cerrar con Escape.
	const visible = Boolean(show && mostrar);

	if (blank) {
		return (
			visible && (
				<div className={`popup ${visible ? "active" : ""}`}>
					<div
						className={`popup__content ${classes.content}`}
						style={{ maxWidth: modalSize(), borderRadius: '5px' }}
					>
						{children}
					</div>
					<div className="popup__overlay"></div>
				</div>
			)
		);
	}

	return (
		visible && (
			<div className={`popup ${visible ? "active" : ""}`}>
				<div
					className={`popup__content ${classes.content}`}
					style={{ maxWidth: modalSize() }}
				>
					<div className={`popup__header ${classes.header}`}>{title}</div>
					<div className={`popup__body ${classes.body}`}>{children}</div>
					<div className={`popup__footer ${classes.footer}`}>
						{footer ? (
							<>{footer}</>
						) : (
							<>
								{showCancelBtn && (
									<button
										type="button"
										onClick={() => {
											setMostrar(false);
											toggle();
										}}
										className="btn btn-plain"
									>
										Cancelar
									</button>
								)}
                                {saving ? <Loader type="small" /> : (
                                    <button
                                        type="button"
                                        onClick={callbackWrapper}
                                        className="btn btn-primary"
                                    >
                                        {acceptText || "Aceptar"}
                                    </button>
                                )}
							</>
						)}
					</div>
				</div>
				<div className="popup__overlay"></div>
			</div>
		)
	);
}
